import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import GeneralLedger from "../../../containers/modules/report/general-ledger";

export default function GeneralLedgerRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="general-ledger"
      index
      element={
        <AccessControl
          name={"General Ledger Show"}
          auth={authUser}
          component={() => <GeneralLedger />}
        />
      }
    ></Route>
  );
}
